module.exports = __webpack_public_path__ + "static/media/image1.45ba3af3.jpg";